import _ from 'lodash';

class AdvertisementStore {
  constructor() {
    this.bindActions(this.alt.getActions('Advertisement'));
    this.showAds = true;
    this.targetKeys = {};
    this.targetKeysBySource = {};
    this.errors = {};
  }

  onUpdateAdsSuccess(showAds) {
    this.showAds = showAds;
    delete this.errors['showAds'];
  }

  onUpdateAdsFail({error}){
    this.errors['showAds'] = error;
  }

  onUpdateTargetingKeyValueSuccess([key, value, source]) {
    _.set(this.targetKeysBySource, `${key}.${source}`, value);
    this._updateTargetingKeyValue(key);
  }

  onUpdateTargetingKeyValueFail({error}) {
    this.errors['updateTargetingKeyValue'] = error;
  }

  _updateTargetingKeyValue(key) {
    const { app, route, primaryContentSource } = this.targetKeysBySource[key] || {};
    this.targetKeys[key] = route || primaryContentSource || app;
  }
}

export default AdvertisementStore;



// WEBPACK FOOTER //
// ./app/flux/stores/Advertisement.js